import { EditReferencesState, DocumentToStoreModel, DocumentToStoreViewModel, CabinetModel, SchemaModel, TargetDocumentTypeSettingsModel, ExistingDocumentOption, PagesStoreMode } from '@/types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: EditReferencesState = {
  isLoading: true,
  isDirty: false,
  isReadonly: false,
  error: false,
  errorMessage: '',
  documentToStore: {} as DocumentToStoreModel,
  initialSchema: [] as SchemaModel[],
  initialDocumentDate: null,
  initialMultiValueReferences: [],
  documentToStoreView: {
    cabinets: [] as CabinetModel[],
    dynamicFormSchema: [] as SchemaModel[],
    targetDocumentTypeSettings: {} as TargetDocumentTypeSettingsModel
  } as DocumentToStoreViewModel,
  selectedSourceDocumentTypeId: 0,
  selectedTargetCabinetId: '',
  selectedPages: '1',
  extendingDocumentToStoreLock: false,
  existingDocumentId: 0,
  existingDocumentOption: ExistingDocumentOption.AddToDocument,
  pagesStoreMode: PagesStoreMode.NoSplitting,
  pageViewedBeforeAddToExisting: 1,
  targetDocumentTypeId: null
};

const namespaced: boolean = true;

export const editReferences = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
